import { render } from "./CurrentCompanyEdit.vue?vue&type=template&id=d25cb9ba&ts=true"
import script from "./CurrentCompanyEdit.vue?vue&type=script&lang=ts"
export * from "./CurrentCompanyEdit.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__